import { getKeyboardFocusableElements, getElementFromEvent } from '../utils';

class Form {
	constructor(el) {
		this.el = el;
		this.form = this.el.querySelector('[data-modal-form]');
		this.previouslyFocused = null;

		this.closeButton = this.el.querySelector('[data-modal-close]');

		this.closeButton.addEventListener('click', (e) => {
			this.closeModal();
		});

		// Event listeners
		this.boundHandleKeys = this.handleKeys.bind(this);

		this.el.addEventListener('click', (e) => {
			const backdrop = getElementFromEvent(e, '[data-modal-backdrop]');

			if (backdrop) {
				this.closeModal();
				return;
			}
		});
	}

	handleKeys(e) {
		if (e.key === 'Escape') {
			this.closeModal();
		}

		if (e.key === 'Tab') {
			this.tabFocus(e);
		}
	}

	tabFocus(e) {
		if (!this.open) {
			return;
		}

		const focusableElements = getKeyboardFocusableElements(this.el);
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		}
	}

	get open() {
		return this.el.classList.contains('is-active');
	}

	openModal(target) {
		if (this.open) {
			return;
		}
		document.addEventListener('keydown', this.boundHandleKeys);

		this.previouslyFocused = document.activeElement;

		this.el.classList.add('is-active');

		if (target) {
			this.loadUrl(target);
		}

		const focusableElements = getKeyboardFocusableElements(this.el);

		if (focusableElements.length) {
			focusableElements[0].focus();
		}
	}

	loadUrl(url) {
		const container = this.el.querySelector('[data-role="container"]');
		container.innerHTML = 'Loading...';

		fetch(url)
			.then((res) => res.text())
			.then((html) => {
				container.innerHTML = html;

				var parser = new DOMParser();
				var htmlDoc = parser.parseFromString(html, 'text/html');
				const scripts = htmlDoc.getElementsByTagName('script');

				function evalInWindow(src) {
					const func = function () {
						eval(src);
					};

					//define event to prevent errors in gform javascript
					const backup = window.event;
					window.event = {};
					func.call(window);
					delete window.event;

					if (backup !== undefined) {
						window.event = backup;
					}else{
						window.event = {
							preventDefault() {}
						};
					}
				}

				[...scripts].forEach((script) => {
					if (script.hasAttribute('data-barba-include')) {
						let src = script.innerHTML;
						try {
							console.log({ src });
							evalInWindow(src);
						} catch (e) {
							console.error(e);
						}
					}
				});
			});
	}

	closeModal() {
		if (!this.open) {
			return;
		}

		document.removeEventListener('keydown', this.boundHandleKeys);

		this.el.classList.remove('is-active');

		if (this.previouslyFocused && this.previouslyFocused.focus) {
			this.previouslyFocused.focus();
		}
	}
}

export default class Modal {
	constructor() {
		this.modal = new Form(document.querySelector('[data-modal]'));

		document.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const link = e.target?.closest('[data-open-modal]');

			if (!link) {
				return;
			}

			e.preventDefault();
			this.modal.openModal(link.dataset.openModal);
		});
	}
}
